module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJBJREFUOBHtUkEOgCAMI+JXfJGfIVz0Q35I3wIIh+2gHSxGDyZw2ejaAg3G9CUl4JzbpZmEI80AyBPAWtBNg4xbJqp5N+aYxCi89yuzhKbGGZGmCGKMS648ttZuZRNCmAkkTq4EcRVvzIy3mvzZU/GqPZPOIg5pCIdVRbookeazKLoxp4+iOHiqb55o9O7/Zp6CFSqrQulSOwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_WidthMax_disabled.png
// module id = 322
// module chunks = 0